import { all, fork, put, takeLatest, call, takeEvery } from 'redux-saga/effects';
import {
    getOptimizedCarriers,
    getOptimizedTransitTimeByDayServiceLevel,   
    getOptimizedTotalCost,
    getOptimizedAvgCost,
    getOptimizedAggregatedCostByService,
    getOptimizedShipFromLocations,
} from '../../helpers';
import {
    carrierOptimizationsApiResponseSuccess,
    carrierOptimizationsApiResponseError,
} from './actions';
import { CarrierOptimizationsActionTypes } from './constants';

export function* getOptimizedCarriersSaga({ payload: { query } }) {
    try {
        const response = yield call(getOptimizedCarriers, query);
        yield put(carrierOptimizationsApiResponseSuccess(CarrierOptimizationsActionTypes.GET_OPTIMIZED_CARRIERS, response.data));
    } catch (error) {
        yield put(carrierOptimizationsApiResponseError(CarrierOptimizationsActionTypes.GET_OPTIMIZED_CARRIERS, error));
    }
}

export function* getOptimizedTransitTimeByDayServiceLevelSaga({ payload: { query } }) {
    try {
        const response = yield call(getOptimizedTransitTimeByDayServiceLevel, query);
        yield put(carrierOptimizationsApiResponseSuccess(CarrierOptimizationsActionTypes.GET_OPTIMIZED_TRANSIT_TIME_BY_DAY_SERVICE_LEVEL, response.data));
    } catch (error) {
        yield put(carrierOptimizationsApiResponseError(CarrierOptimizationsActionTypes.GET_OPTIMIZED_TRANSIT_TIME_BY_DAY_SERVICE_LEVEL, error));
    }
}

export function* getOptimizedTotalCostSaga({ payload: { query } }) {
    try {
        const response = yield call(getOptimizedTotalCost, query);
        yield put(carrierOptimizationsApiResponseSuccess(CarrierOptimizationsActionTypes.GET_OPTIMIZED_TOTAL_COST, response.data));
    } catch (error) {
        yield put(carrierOptimizationsApiResponseError(CarrierOptimizationsActionTypes.GET_OPTIMIZED_TOTAL_COST, error));
    }
}   

export function* getOptimizedAvgCostSaga({ payload: { query } }) {
    try {
        const response = yield call(getOptimizedAvgCost, query);
        yield put(carrierOptimizationsApiResponseSuccess(CarrierOptimizationsActionTypes.GET_OPTIMIZED_AVG_COST, response.data));
    } catch (error) {
        yield put(carrierOptimizationsApiResponseError(CarrierOptimizationsActionTypes.GET_OPTIMIZED_AVG_COST, error));
    }
}

export function* getOptimizedAggregatedCostByServiceSaga({ payload: { query } }) {
    try {
        const response = yield call(getOptimizedAggregatedCostByService, query);
        yield put(carrierOptimizationsApiResponseSuccess(CarrierOptimizationsActionTypes.GET_OPTIMIZED_AGGREGATED_COST_BY_SERVICE, response.data));
    } catch (error) {
        yield put(carrierOptimizationsApiResponseError(CarrierOptimizationsActionTypes.GET_OPTIMIZED_AGGREGATED_COST_BY_SERVICE, error));
    }
}

export function* getOptimizedShipFromLocationsSaga({ payload: { query } }) {
    try {
        const response = yield call(getOptimizedShipFromLocations, query);
        yield put(carrierOptimizationsApiResponseSuccess(CarrierOptimizationsActionTypes.GET_OPTIMIZED_SHIP_FROM_LOCATIONS, response.data));
    } catch (error) {
        yield put(carrierOptimizationsApiResponseError(CarrierOptimizationsActionTypes.GET_OPTIMIZED_SHIP_FROM_LOCATIONS, error));
    }
}

export function* watchGetOptimizedCarriersSaga() {
    yield takeLatest(CarrierOptimizationsActionTypes.GET_OPTIMIZED_CARRIERS, getOptimizedCarriersSaga);
}

export function* watchGetOptimizedTransitTimeByDayServiceLevelSaga() {
    yield takeLatest(CarrierOptimizationsActionTypes.GET_OPTIMIZED_TRANSIT_TIME_BY_DAY_SERVICE_LEVEL, getOptimizedTransitTimeByDayServiceLevelSaga);
}

export function* watchGetOptimizedTotalCostSaga() {
    yield takeLatest(CarrierOptimizationsActionTypes.GET_OPTIMIZED_TOTAL_COST, getOptimizedTotalCostSaga);
}

export function* watchGetOptimizedAvgCostSaga() {
    yield takeLatest(CarrierOptimizationsActionTypes.GET_OPTIMIZED_AVG_COST, getOptimizedAvgCostSaga);
}

export function* watchGetOptimizedAggregatedCostByServiceSaga() {
    yield takeLatest(CarrierOptimizationsActionTypes.GET_OPTIMIZED_AGGREGATED_COST_BY_SERVICE, getOptimizedAggregatedCostByServiceSaga);
}

export function* watchGetOptimizedShipFromLocationsSaga() {
    yield takeLatest(CarrierOptimizationsActionTypes.GET_OPTIMIZED_SHIP_FROM_LOCATIONS, getOptimizedShipFromLocationsSaga);
}

function* carrierOptimizationsSaga() {
    yield all([
        fork(watchGetOptimizedCarriersSaga),
        fork(watchGetOptimizedTransitTimeByDayServiceLevelSaga),
        fork(watchGetOptimizedTotalCostSaga),
        fork(watchGetOptimizedAvgCostSaga),
        fork(watchGetOptimizedAggregatedCostByServiceSaga),
        fork(watchGetOptimizedShipFromLocationsSaga),
    ]);
}

export default carrierOptimizationsSaga;
